export default __webpack_public_path__ + "static/media/services_and_accessories.1988f802.svg";